import { Controller } from "@hotwired/stimulus";
import "./component.scss";

// Copies the recruiting link and confirms it in the subtitle, which is the only spot
// the design leaves for feedback. The original text is captured per click rather than
// on connect, so a double click cannot leave "Link kopiert!" as the permanent subtitle.
//
// The confirmed state is a DATA ATTRIBUTE, never a class: postcss-modules rewrites the
// stylesheet's class names to `c-affiliate-rewards--recruit-link-*`, so a raw class
// added here would match no rule at all.
export default class extends Controller {
  static targets = ["subtitle"];
  static values = { url: String, copied: String };

  async copy() {
    if (!this.urlValue) return;

    try {
      await navigator.clipboard.writeText(this.urlValue);
      this.#confirm();
    } catch (error) {
      console.error("Failed to copy recruiting link:", error);
    }
  }

  #confirm() {
    if (!this.hasSubtitleTarget || !this.copiedValue) return;

    clearTimeout(this.resetTimeout);
    this.original ??= this.subtitleTarget.textContent;
    this.subtitleTarget.textContent = this.copiedValue;
    this.element.dataset.copied = "true";

    this.resetTimeout = setTimeout(() => this.#reset(), 2000);
  }

  #reset() {
    this.subtitleTarget.textContent = this.original;
    delete this.element.dataset.copied;
    this.original = null;
  }

  // A disconnect mid-timeout would otherwise fire #reset against a detached element —
  // this card sits inside Turbo-replaced frames on both surfaces it renders on.
  disconnect() {
    clearTimeout(this.resetTimeout);
  }
}
